import { customAxios } from "./customAxios";

/**
 * 유지보수 > 보고서&자료실 > 현황분석보고서 - 설비별 현황
 * @param {*} query 
 * @returns 
 */
export const getReportCountGroupByCtgr123AndSubwayLineByQueryString = async(query)=>{
  const res = await customAxios.get('/api/report/countGroupByCtgr123AndSubwayLine' + query);
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 유지보수 > 보고서&자료실 > 현황분석보고서 - 역사별 현황
 * @param {*} query 
 * @returns 
 */
export const getReportCountGroupByCtgr12AndStationByQuery = async(query)=>{
  const res = await customAxios.get('/api/report/countGroupByCtgr12AndStation', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 유지보수 > 보고서&자료실 > 유지보수분석보고서 – 종합보고서(그래프)
 * @param {*} query 
 * @returns 
 */
export const getReportCountMntTaskGroupByCtgr1ByQuery = async(query)=>{
  const res = await customAxios.get('/api/report/countMntTaskGroupByCtgr1', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 유지보수 > 보고서&자료실 > 유지보수분석보고서 – 종합보고서(목록)
 * @param {*} query 
 * @returns 
 */
export const getReportCountMntTaskGroupByCtgr1AndSubwayLineByQuery = async(query)=>{
  const res = await customAxios.get('/api/report/countMntTaskGroupByCtgr1AndSubwayLine', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 유지보수 > 보고서&자료실 > 유지보수분석보고서 – 종합보고서(유지보수 증감[년도만 선택])
 * @param {*} query 
 * @returns 
 */
export const getReportCountYearlyMntTaskGroupByCtgr1ForTwoYearsByQuery = async(query)=>{
  const res = await customAxios.get('/api/report/countYearlyMntTaskGroupByCtgr1ForTwoYears', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 유지보수 > 보고서&자료실 > 유지보수분석보고서 – 종합보고서(유지보수 증감[년도, 분기 선택])
 * @param {*} query 
 * @returns 
 */
export const getReportCountQuarterlyMntTaskGroupByCtgr1ForTwoYearsByQuery = async(query)=>{
  const res = await customAxios.get('/api/report/countQuarterlyMntTaskGroupByCtgr1ForTwoYears', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 유지보수 > 보고서&자료실 > 유지보수분석보고서 – 설비별 보고서(그래프)
 * @param {*} query 
 * @returns 
 */
export const getReportCountMntTaskGroupByCtgr3ByQuery = async(query)=>{
  const res = await customAxios.get('/api/report/countMntTaskGroupByCtgr3', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 유지보수 > 보고서&자료실 > 유지보수분석보고서 – 설비별 보고서(목록)
 * @param {*} query 
 * @returns 
 */
export const getReportCountMntTaskGroupByCtgr23AndSubwayLineByQuery = async(query)=>{
  const res = await customAxios.get('/api/report/countMntTaskGroupByCtgr23AndSubwayLine', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 유지보수 > 보고서&자료실 > 유지보수분석보고서 – 설비별 보고서(유지보수 증감[년도만 선택])
 * @param {*} query 
 * @returns 
 */
export const getReportCountYearlyMntTaskGroupByCtgr23ForTwoYearsByQuery = async(query)=>{
  const res = await customAxios.get('/api/report/countYearlyMntTaskGroupByCtgr23ForTwoYears', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 유지보수 > 보고서&자료실 > 유지보수분석보고서 – 설비별 보고서(유지보수 증감[년도, 분기 선택])
 * @param {*} query 
 * @returns 
 */
export const getReportCountQuarterlyMntTaskGroupByCtgr23ForTwoYearsByQuery = async(query)=>{
  const res = await customAxios.get('/api/report/countQuarterlyMntTaskGroupByCtgr23ForTwoYears', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 유지보수 > 보고서&자료실 > 유지보수분석보고서 – 설비별 보고서(구성부별 조치유형)
 * @param {*} query 
 * @returns 
 */
export const getReportCountMntTaskGroupByCtgr234AndPositionAndMntTypeByQuery = async(query)=>{
  const res = await customAxios.get('/api/report/countMntTaskGroupByCtgr234AndPositionAndMntType', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 유지보수 > 보고서&자료실 > 유지보수분석보고서 – 설비별 보고서(구성부별 장애유형)
 * @param {*} query 
 * @returns 
 */
export const getReportCountMntTaskGroupByCtgr234AndPositionAndRecordTypeByQuery = async(query)=>{
  const res = await customAxios.get('/api/report/countMntTaskGroupByCtgr234AndPositionAndRecordType', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 유지보수 > 보고서&자료실 > 유지보수분석보고서 – 설비별 보고서(제조업체별 조치유형)
 * @param {*} query 
 * @returns 
 */
export const getReportCountMntTaskGroupByCtgr234AndMfCpnyNmAndMntTypeByQuery = async(query)=>{
  const res = await customAxios.get('/api/report/countMntTaskGroupByCtgr234AndMfCpnyNmAndMntType', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 유지보수 > 보고서&자료실 > 유지보수분석보고서 – 설비별 보고서(자재별 조치유형)
 * @param {*} query 
 * @returns 
 */
export const getReportCountMntTaskGroupByCtgr234AndEquipmentPartAndMntTypeByQuery = async(query)=>{
  const res = await customAxios.get('/api/report/countMntTaskGroupByCtgr234AndEquipmentPartAndMntType', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}


/**
 * 유지보수 > 보고서&자료실 > 유지보수분석보고서 – 역사별 보고서(그래프)
 * @param {*} query 
 * @returns 
 */
export const getReportCountMntTaskGroupByStationByQuery = async(query)=>{
  const res = await customAxios.get('/api/report/countMntTaskGroupByStation', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 유지보수 > 보고서&자료실 > 유지보수분석보고서 – 역사별 보고서(목록)
 * @param {*} query 
 * @returns 
 */
export const getReportCountMntTaskGroupByCtgr3AndPartAndStationByQuery = async(query)=>{
  const res = await customAxios.get('/api/report/countMntTaskGroupByCtgr3AndPartAndStation', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 유지보수 > 보고서&자료실 > 유지보수분석보고서 – 역사별 보고서(유지보수 증감[년도만 선택])
 * @param {*} query 
 * @returns 
 */
export const getReportCountYearlyMntTaskGroupByCtgr23AndPartForTwoYearsByQuery = async(query)=>{
  const res = await customAxios.get('/api/report/countYearlyMntTaskGroupByCtgr23AndPartForTwoYears', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 유지보수 > 보고서&자료실 > 유지보수분석보고서 – 역사별 보고서(유지보수 증감[년도, 분기 선택])
 * @param {*} query 
 * @returns 
 */
export const getReportCountQuarterlyMntTaskGroupByCtgr23AndPartForTwoYearsByQuery = async(query)=>{
  const res = await customAxios.get('/api/report/countQuarterlyMntTaskGroupByCtgr23AndPartForTwoYears', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 유지보수 > 보고서&자료실 > 유지보수분석보고서 – Iot진단보고서
 * @param {*} query 
 * @returns 
 */
export const getReportresultVibrationDiagnosesWithRatingByQueryString = async(query)=>{
  const res = await customAxios.get('/api/resultVibrationDiagnoses/:withRating'+ query);
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 유지보수 > 보고서 > 유지보수분석보고서 – Iot진단보고서(진동)
 * @param {*} query 
 * @returns 
 */
export const getDiagnosisResultVibrationByQueryString = async(query)=>{
  const res = await customAxios.get('/api/diagnosisResultVibration'+ query);
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 유지보수 > 보고서 > 유지보수분석보고서 – Iot진단보고서(소음)
 * @param {*} query 
 * @returns 
 */
export const getDiagnosisResultNoiseByQueryString = async(query)=>{
  const res = await customAxios.get('/api/diagnosisResultNoise'+ query);
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 유지보수 > 보고서 > 유지보수분석보고서 – Iot진단보고서(V-Belt)
 * @param {*} query 
 * @returns 
 */
export const getDiagnosisResultVbeltByQueryString = async(query)=>{
  const res = await customAxios.get('/api/diagnosisResultVbelt'+ query);
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 유지보수 > 보고서 > 유지보수분석보고서 – Iot진단보고서(체인)
 * @param {*} query 
 * @returns 
 */
export const getDiagnosisResultChainByQueryString = async(query)=>{
  const res = await customAxios.get('/api/diagnosisResultChain'+ query);
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 유지보수 > 보고서 > 유지보수분석보고서 – Iot진단보고서(설비온도)
 * @param {*} query 
 * @returns 
 */
export const getEquipmentTemperatureByQueryString = async(query)=>{
  const res = await customAxios.get('/api/equipmentTemperature'+ query);
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 유지보수 > 보고서 > 유지보수분석보고서 - 진단위치(진동)
 * @param {*} query 
 * @returns 
 */
export const getEquipmentPartsDiagnosisPositionsByVibrationByQuery = async(id, query)=>{
  const res = await customAxios.get('/api/equipmentParts/equipments/'+id+':relatedToLatestDiagnosisResultVibration', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 유지보수 > 보고서 > 유지보수분석보고서 - 진단위치(소음)
 * @param {*} query 
 * @returns 
 */
export const getEquipmentPartsDiagnosisPositionsByNoiseByQuery = async(id, query)=>{
  const res = await customAxios.get('/api/equipmentParts/equipments/'+id+':relatedToLatestDiagnosisResultNoise', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 유지보수 > 보고서 > 유지보수분석보고서 - 진단위치(V-Belt)
 * @param {*} query 
 * @returns 
 */
export const getEquipmentPartsDiagnosisPositionsByVbeltByQuery = async(id, query)=>{
  const res = await customAxios.get('/api/equipmentParts/equipments/'+id+':relatedToLatestDiagnosisResultVbelt', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 유지보수 > 보고서 > 유지보수분석보고서 - 진단위치(체인)
 * @param {*} query 
 * @returns 
 */
export const getEquipmentPartsDiagnosisPositionsByChainByQuery = async(id, query)=>{
  const res = await customAxios.get('/api/equipmentParts/equipments/'+id+':relatedToLatestDiagnosisResultChain', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 유지보수 > 보고서 > 유지보수분석보고서 - 진단위치(설비 온도)
 * @param {*} query 
 * @returns 
 */
export const getEquipmentPartsDiagnosisPositionsByTemperatureByQuery = async(id, query)=>{
  const res = await customAxios.get('/api/equipmentParts/equipments/'+id+':relatedToLatestEquipmentTemperature', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 유지보수 > 보고서&자료실 > 경보현황보고서 – 경보현황(그래프)
 * @param {*} query 
 * @returns 
 */
export const getReportCountEquipmentAlertGroupByCtgr1AndSubwayLineByQuery = async(query)=>{
  const res = await customAxios.get('/api/report/countEquipmentAlertGroupByCtgr1AndSubwayLine', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}


/**
 * 유지보수 > 보고서&자료실 > 경보현황보고서 – 결함유형
 * @param {*} query 
 * @returns 
 */
export const getReportCountEquipmentAlertGroupByDiagnosisCodesAndSubwayLineByQuery = async(query)=>{
  const res = await customAxios.get('/api/report/countEquipmentAlertGroupByDiagnosisCodesAndSubwayLine', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 종합보고서 > 유지보수 통계(구성부별)
 * @param {*} query 
 * @returns 
 */
export const getReportCountMtnTaskGroupByCategory4ByEquipmentIdByQuery = async(query)=>{
  const res = await customAxios.get('/api/report/countMtnTaskGroupByCategory4ByEquipmentId', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 종합보고서 > 유지보수 통계(자재별)
 * @param {*} query 
 * @returns 
 */
export const getReportCountMtnTaskGroupByEquipmentPartByEquipmentIdByQuery = async(query)=>{
  const res = await customAxios.get('/api/report/countMtnTaskGroupByEquipmentPartByEquipmentId', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 종합보고서 > 예방점검필요 부품
 * @param {*} query 
 * @returns 
 */
export const getReportFindReplaceTargetTopNByEquipmentIdByQuery = async(query)=>{
  const res = await customAxios.get('/api/report/findReplaceTargetTopNByEquipmentId', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 종합보고서 > ISO기준 진동량 측정
 * @param {*} query 
 * @returns 
 */
export const getReportFindLatestRVRByEquipmentIdByQuery = async(query)=>{
  const res = await customAxios.get('/api/report/findLatestRVRByEquipmentId', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 종합보고서 >  V벨트/동력전단율
 * @param {*} query 
 * @returns 
 */
export const getReportFindLatestRVEByEquipmentIdByQuery = async(query)=>{
  const res = await customAxios.get('/api/report/findLatestRVEByEquipmentId', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}


/**
 * 종합보고서 > ISO기준 진동량(new)
 * @param {*} query 
 * @returns 
 */
export const getLatestDiagnosisResultVibrationsByEquipmentId = async(id)=>{
  const res = await customAxios.get('/api/report/latestDiagnosisResultVibrations/equipment/'+id);
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 종합보고서 > ISO기준 소음(new)
 * @param {*} query 
 * @returns 
 */
export const getLatestDiagnosisResultNoisesByEquipmentId = async(id)=>{
  const res = await customAxios.get('/api/report/latestDiagnosisResultNoises/equipment/'+id);
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 종합보고서 > ISO기준 체인(new)
 * @param {*} query 
 * @returns 
 */
export const getLatestDiagnosisResultChainsByEquipmentId = async(id)=>{
  const res = await customAxios.get('/api/report/latestDiagnosisResultChains/equipment/'+id);
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 종합보고서 > ISO기준 V-Belt(new)
 * @param {*} query 
 * @returns 
 */
export const getLatestDiagnosisResultVbeltsByEquipmentId = async(id)=>{
  const res = await customAxios.get('/api/report/latestDiagnosisResultVbelts/equipment/'+id);
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 종합보고서 > ISO기준 설비 온도(new)
 * @param {*} query 
 * @returns 
 */
export const getLatestEquipmentTemperaturesByEquipmentId = async(id)=>{
  const res = await customAxios.get('/api/report/latestEquipmentTemperatures/equipment/'+id);
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 종합보고서 > 고장예측 정보
 * @param {*} query 
 * @returns 
 */
export const getReportFindLatestRVDByEquipmentIdByQuery = async(query)=>{
  const res = await customAxios.get('/api/report/findLatestRVDByEquipmentId', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 종합보고서 > 공조설비 잔여수명
 * @param {*} query 
 * @returns 
 */
export const getReportResultLifeEstimatesByQuery = async(query)=>{
  const res = await customAxios.get('/api/resultLifeEstimates', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}
